import _ from 'lodash';
import { IAppointment } from 'src/interfaces/appointment';

export const getLastAppointment = (appointments: IAppointment[]) => {
    const lastAppointment = _.last(appointments);
    return lastAppointment;
};
